module.exports = "/_next/static/fonts/ABCSocialCondensed-Black-dbd2f478dc171b82495572d223baf429.woff2";